import React from 'react';
import { BsTwitter, BsInstagram } from 'react-icons/bs';
import { AiFillGithub } from 'react-icons/ai';

const SocialMedia = () => {
  return (
    <div className='app__social'>
      
      <div>
      <a href="https://twitter.com/_developedbyme">
        <BsTwitter />
        </a>
      </div>

      <div>
        <a href="https://github.com/jurbingordonez">
        <AiFillGithub />
        </a>
      </div>

      <div>
        <a href="https://www.instagram.com/_developedbyme/">
        <BsInstagram />
        </a>
      </div>
      
      </div>
  )
}

export default SocialMedia